import React from "react";
function Inventory({ label, table, capacity, venu_capacity }) {
  return (
    <>
      <div className="mb-3">
        <div className="grid grid-cols-2 bg-white p-3">
          <div className="bg-[#f0f2f7] rounded-2 h-full flex justify-center items-center">
            {table}
          </div>
          <div className="h-full p-2">
            <h5 className="font-semibold text-[#4186C2] mb-3">{label}</h5>
            <p className="text-[10px]">
              Capacity: <span className="text-[#4186C2]">{capacity}</span>
            </p>
            <p className="text-[10px]">
              Venue Capacity:{" "}
              <span className="text-[#4186C2]">{venu_capacity}</span>
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default Inventory;
